const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "calendar":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "calendar",
    reducer: reducer,
};

export default data;